import { ICountriesState, initialState } from './countries';
import { RSAA } from 'redux-api-middleware';
import getCountriesURL from 'url-constructors/getCountriesURL';
import { Dispatch } from 'redux';
import { TGetRootState, TAsyncDispatchResult } from 'types/shared';
import { ICountryFlagProps } from 'types/shared';

const REQUEST = 'opus/ex-countries/REQUEST';
const SUCCESS = 'opus/ex-countries/SUCCESS';
const FAILURE = 'opus/ex-countries/FAILURE';

type CountriesActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE;

interface ICountriesAction {
  type: CountriesActionTypes;
  payload: ICountryFlagProps[];
}

function reducer(
  state: ICountriesState = initialState,
  action: ICountriesAction
): ICountriesState {
  switch (action.type) {
    case REQUEST: {
      return {
        ...state,
        pending: true,
        fulfilled: false,
        error: false,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        pending: false,
        fulfilled: true,
        error: false,
        data: action.payload,
      };
    }
    case FAILURE: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: true,
        reason: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

function loadExCountries(): TAsyncDispatchResult {
  return async function (
    dispatch: Dispatch,
    getState: TGetRootState
  ): Promise<any> {
    const { exCountries } = getState();

    return await dispatch({
      [RSAA]: {
        bailout: exCountries.pending || exCountries.fulfilled,
        types: [
          REQUEST,
          {
            type: SUCCESS,
            payload: async function payload(
              action: ICountriesAction,
              state: ICountriesState,
              res: any
            ): Promise<ICountryFlagProps[]> {
              const json = await res.json();
              return json.data.map((excludeCountry: ICountryFlagProps) => ({
                ...excludeCountry,
                isEx: true,
              }));
            },
          },
          FAILURE,
        ],
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        method: 'GET',
        endpoint: getCountriesURL({ isExCountries: true }),
      },
    });
  };
}

export { loadExCountries };
export default reducer;
